import { Job } from './Job'
import { loadIntegratedJobRelatedFunc } from '@/api/integratedJob/ieBooking'
import { checkJobFiledExist } from '@/api/seaExport/seaExportJob'

export class IntegratedJob extends Job {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'IntegratedJob'
  }
  get subTenantId() {
    return this._data.subTenantId
  }

  set subTenantId(subTenantId) {
    this._data.subTenantId = subTenantId
  }
  get truckCsr() {
    return this._data.truckCsr
  }
  set truckCsr(truckCsr) {
    this._data.truckCsr = truckCsr
  }
  get truckDept() {
    return this._data.truckDept
  }
  set truckDept(truckDept) {
    this._data.truckDept = truckDept
  }
  get transportType() {
    return this._data.transportType
  }
  set transportType(transportType) {
    this._data.transportType = transportType
  }
  get containerLoadType() {
    return this._data.containerLoadType
  }
  set containerLoadType(containerLoadType) {
    this._data.containerLoadType = containerLoadType
  }
  get operateType() {
    return this._data.operateType
  }
  set operateType(operateType) {
    this._data.operateType = operateType
  }
  get truckingInfoType() {
    return this._data.truckingInfoType || 0
  }
  set truckingInfoType(truckingInfoType) {
    this._data.truckingInfoType = truckingInfoType
  }

  get customs() {
    return this._data.customs
  }
  set customs(customs) {
    this._data.customs = customs
  }
  get portDistrict() {
    return this._data.portDistrict
  }
  set portDistrict(portDistrict) {
    this._data.portDistrict = portDistrict
  }
  get terminalOpenDate() {
    return this._data.terminalOpenDate
  }
  set terminalOpenDate(terminalOpenDate) {
    this._data.terminalOpenDate = terminalOpenDate
  }
  get terminalCutoff() {
    return this._data.terminalCutoff
  }
  set terminalCutoff(terminalCutoff) {
    this._data.terminalCutoff = terminalCutoff
  }

  get freeDetention() {
    return this._data.freeDetention
  }
  set freeDetention(freeDetention) {
    this._data.freeDetention = freeDetention
  }
  get freeDemurrage() {
    return this._data.freeDemurrage
  }
  set freeDemurrage(freeDemurrage) {
    this._data.freeDemurrage = freeDemurrage
  }
  get customsAreaApplication() {
    return this._data.customsAreaApplication
  }
  set customsAreaApplication(customsAreaApplication) {
    this._data.customsAreaApplication = customsAreaApplication
  }

  get truckWarehouseCmp() {
    return this._data.truckWarehouseCmp
  }
  set truckWarehouseCmp(truckWarehouseCmp) {
    this._data.truckWarehouseCmp = truckWarehouseCmp
  }
  get truckWarehouseContact() {
    return this._data.truckWarehouseContact
  }
  set truckWarehouseContact(truckWarehouseContact) {
    this._data.truckWarehouseContact = truckWarehouseContact
  }
  get truckWarehouseName() {
    return this._data.truckWarehouseName
  }
  set truckWarehouseName(truckWarehouseName) {
    this._data.truckWarehouseName = truckWarehouseName
  }
  get truckWarehouseContactTel() {
    return this._data.truckWarehouseContactTel
  }
  set truckWarehouseContactTel(truckWarehouseContactTel) {
    this._data.truckWarehouseContactTel = truckWarehouseContactTel
  }
  get truckWarehouseLoadingRemarks() {
    return this._data.truckWarehouseLoadingRemarks
  }
  set truckWarehouseLoadingRemarks(truckWarehouseLoadingRemarks) {
    this._data.truckWarehouseLoadingRemarks = truckWarehouseLoadingRemarks
  }
  get truckWarehouseAddress() {
    return this._data.truckWarehouseAddress
  }
  set truckWarehouseAddress(truckWarehouseAddress) {
    this._data.truckWarehouseAddress = truckWarehouseAddress
  }
  get waybillDestination() {
    return this._data.waybillDestination
  }
  set waybillDestination(waybillDestination) {
    this._data.waybillDestination = waybillDestination
  }
  get polCountry() {
    return this._data.polCountry
  }
  set polCountry(polCountry) {
    this._data.polCountry = polCountry
  }
  get transferAgent() {
    return this._data.transferAgent
  }
  set transferAgent(transferAgent) {
    this._data.transferAgent = transferAgent || 0
  }
  get customsMethodPol() {
    return this._data.customsMethodPol
  }
  set customsMethodPol(customsMethodPol) {
    this._data.customsMethodPol = customsMethodPol
  }
  get incoTerm() {
    return this._data.incoTerm
  }
  set incoTerm(incoTerm) {
    this._data.incoTerm = incoTerm
  }
  get waybillInvoice() {
    return this._data.waybillInvoice
  }
  set waybillInvoice(waybillInvoice) {
    this._data.waybillInvoice = waybillInvoice
  }
  get vehicleType() {
    return this._data.vehicleType
  }
  set vehicleType(vehicleType) {
    this._data.vehicleType = vehicleType
  }
  get plateNumber() {
    return this._data.plateNumber
  }
  set plateNumber(plateNumber) {
    this._data.plateNumber = plateNumber
  }
  get trailerNumber() {
    return this._data.trailerNumber
  }
  set trailerNumber(trailerNumber) {
    this._data.trailerNumber = trailerNumber
  }
  get estLandingTime() {
    return this._data.estLandingTime
  }
  set estLandingTime(estLandingTime) {
    this._data.estLandingTime = estLandingTime
  }
  get actLandingTime() {
    return this._data.actLandingTime
  }
  set actLandingTime(actLandingTime) {
    this._data.actLandingTime = actLandingTime
  }
  get estEntryTime() {
    return this._data.estEntryTime
  }
  set estEntryTime(estEntryTime) {
    this._data.estEntryTime = estEntryTime
  }
  get actEntryTime() {
    return this._data.actEntryTime
  }
  set actEntryTime(actEntryTime) {
    this._data.actEntryTime = actEntryTime
  }
  get estExitTime() {
    return this._data.estExitTime
  }
  set estExitTime(estExitTime) {
    this._data.estExitTime = estExitTime
  }
  get actExitTime() {
    return this._data.actExitTime
  }
  set actExitTime(actExitTime) {
    this._data.actExitTime = actExitTime
  }
  get estReplacementTime() {
    return this._data.estReplacementTime
  }
  set estReplacementTime(estReplacementTime) {
    this._data.estReplacementTime = estReplacementTime
  }
  get actReplacementTime() {
    return this._data.actReplacementTime
  }
  set actReplacementTime(actReplacementTime) {
    this._data.actReplacementTime = actReplacementTime
  }
  get estDeclareTime() {
    return this._data.estDeclareTime
  }
  set estDeclareTime(estDeclareTime) {
    this._data.estDeclareTime = estDeclareTime
  }
  get declareTime() {
    return this._data.declareTime
  }
  set declareTime(declareTime) {
    this._data.declareTime = declareTime
  }
  get estDeclareCompletedTime() {
    return this._data.estDeclareCompletedTime
  }
  set estDeclareCompletedTime(estDeclareCompletedTime) {
    this._data.estDeclareCompletedTime = estDeclareCompletedTime
  }
  get declareCompletedTime() {
    return this._data.declareCompletedTime
  }
  set declareCompletedTime(declareCompletedTime) {
    this._data.declareCompletedTime = declareCompletedTime
  }
  get estShippingTime() {
    return this._data.estShippingTime
  }
  set estShippingTime(estShippingTime) {
    this._data.estShippingTime = estShippingTime
  }
  get actShippingTime() {
    return this._data.actShippingTime
  }
  set actShippingTime(actShippingTime) {
    this._data.actShippingTime = actShippingTime
  }
  get estArrivePodTime() {
    return this._data.estArrivePodTime
  }
  set estArrivePodTime(estArrivePodTime) {
    this._data.estArrivePodTime = estArrivePodTime
  }
  get actArrivePodTime() {
    return this._data.actArrivePodTime
  }
  set actArrivePodTime(actArrivePodTime) {
    this._data.actArrivePodTime = actArrivePodTime
  }
  get estEnterPodTime() {
    return this._data.estEnterPodTime
  }
  set estEnterPodTime(estEnterPodTime) {
    this._data.estEnterPodTime = estEnterPodTime
  }
  get actEnterPodTime() {
    return this._data.actEnterPodTime
  }
  set actEnterPodTime(actEnterPodTime) {
    this._data.actEnterPodTime = actEnterPodTime
  }
  get estArriveClearTime() {
    return this._data.estArriveClearTime
  }
  set estArriveClearTime(estArriveClearTime) {
    this._data.estArriveClearTime = estArriveClearTime
  }
  get actArriveClearTime() {
    return this._data.actArriveClearTime
  }
  set actArriveClearTime(actArriveClearTime) {
    this._data.actArriveClearTime = actArriveClearTime
  }
  get estDischargeTime() {
    return this._data.estDischargeTime
  }
  set estDischargeTime(estDischargeTime) {
    this._data.estDischargeTime = estDischargeTime
  }
  get actDischargeTime() {
    return this._data.actDischargeTime
  }
  set actDischargeTime(actDischargeTime) {
    this._data.actDischargeTime = actDischargeTime
  }
  get estArriveTime() {
    return this._data.estArriveTime
  }
  set estArriveTime(estArriveTime) {
    this._data.estArriveTime = estArriveTime
  }
  get actArriveTime() {
    return this._data.actArriveTime
  }
  set actArriveTime(actArriveTime) {
    this._data.actArriveTime = actArriveTime
  }
  get estTakeTime() {
    return this._data.estTakeTime
  }
  set estTakeTime(estTakeTime) {
    this._data.estTakeTime = estTakeTime
  }
  get actTakeTime() {
    return this._data.actTakeTime
  }
  set actTakeTime(actTakeTime) {
    this._data.actTakeTime = actTakeTime
  }
  get estUnloadTime() {
    return this._data.estUnloadTime
  }
  set estUnloadTime(estUnloadTime) {
    this._data.estUnloadTime = estUnloadTime
  }
  get actUnloadTime() {
    return this._data.actUnloadTime
  }
  set actUnloadTime(actUnloadTime) {
    this._data.actUnloadTime = actUnloadTime
  }
  get secondVehicleType() {
    return this._data.secondVehicleType
  }
  set secondVehicleType(secondVehicleType) {
    this._data.secondVehicleType = secondVehicleType
  }
  get secondPlateNumber() {
    return this._data.secondPlateNumber
  }
  set secondPlateNumber(secondPlateNumber) {
    this._data.secondPlateNumber = secondPlateNumber
  }
  get secondTrailerNumber() {
    return this._data.secondTrailerNumber
  }
  set secondTrailerNumber(secondTrailerNumber) {
    this._data.secondTrailerNumber = secondTrailerNumber
  }
  get secondEtd() {
    return this._data.secondEtd
  }
  set secondEtd(secondEtd) {
    this._data.secondEtd = secondEtd
  }
  get secondPol() {
    return this._data.secondPol
  }
  set secondPol(secondPol) {
    this._data.secondPol = secondPol
  }
  get secondPod() {
    return this._data.secondPod
  }
  set secondPod(secondPod) {
    this._data.secondPod = secondPod
  }
  get secondLoadingTime() {
    return this._data.secondLoadingTime
  }
  set secondLoadingTime(secondLoadingTime) {
    this._data.secondLoadingTime = secondLoadingTime
  }
  get secondShippingTime() {
    return this._data.secondShippingTime
  }
  set secondShippingTime(secondShippingTime) {
    this._data.secondShippingTime = secondShippingTime
  }
  get secondArriveTime() {
    return this._data.secondArriveTime
  }
  set secondArriveTime(secondArriveTime) {
    this._data.secondArriveTime = secondArriveTime
  }
  get secondDischargeTime() {
    return this._data.secondDischargeTime
  }
  set secondDischargeTime(secondDischargeTime) {
    this._data.secondDischargeTime = secondDischargeTime
  }
  get secondTransportType() {
    return this._data.secondTransportType
  }
  set secondTransportType(secondTransportType) {
    this._data.secondTransportType = secondTransportType
  }
  get bargeEtd() {
    return this._data.bargeEtd
  }
  set bargeEtd(bargeEtd) {
    this._data.bargeEtd = bargeEtd
  }
  get bargeAtd() {
    return this._data.bargeAtd
  }
  set bargeAtd(bargeAtd) {
    this._data.bargeAtd = bargeAtd
  }
  get bargePlateNumber() {
    return this._data.bargePlateNumber
  }
  set bargePlateNumber(bargePlateNumber) {
    this._data.bargePlateNumber = bargePlateNumber
  }
  get bargeTrailerNumber() {
    return this._data.bargeTrailerNumber
  }
  set bargeTrailerNumber(bargeTrailerNumber) {
    this._data.bargeTrailerNumber = bargeTrailerNumber
  }
  get bargePol() {
    return this._data.bargePol
  }
  set bargePol(bargePol) {
    this._data.bargePol = bargePol
  }
  get bargePod() {
    return this._data.bargePod
  }
  set bargePod(bargePod) {
    this._data.bargePod = bargePod
  }
  get bargeLine() {
    return this._data.bargeLine
  }
  set bargeLine(bargeLine) {
    this._data.bargeLine = bargeLine
  }
  get bargeClosingDate() {
    return this._data.bargeClosingDate
  }
  set bargeClosingDate(bargeClosingDate) {
    this._data.bargeClosingDate = bargeClosingDate
  }
  get bargeCarrierId() {
    return this._data.bargeCarrierId
  }
  set bargeCarrierId(bargeCarrierId) {
    this._data.bargeCarrierId = bargeCarrierId || 0
  }
  get bargeRemarks() {
    return this._data.bargeRemarks
  }
  set bargeRemarks(bargeRemarks) {
    this._data.bargeRemarks = bargeRemarks
  }
  get copyIntegratedJob() {
    return this._data.copyIntegratedJob
  }
  set copyIntegratedJob(copyIntegratedJob) {
    this._data.copyIntegratedJob = copyIntegratedJob
  }
  get copyTruckingData() {
    return this._data.copyTruckingData
  }
  set copyTruckingData(copyTruckingData) {
    this._data.copyTruckingData = copyTruckingData
  }
  // 检查字段值是否重复
  // static async checkJobFieldExist(branchId, lob, jobFields, jobUuid) {
  //   if(Object.keys(jobFields).length === 0) {
  //     return {}
  //   }
  //   return await checkJobFiledExist({ branchId, lob, jobFields, jobUuid }).then(res => res.data)
  // }
  /* 关联实体-end */
  // 检查字段值是否重复
  static async checkJobFieldExist(branchId, lob, jobFields, jobUuid) {
    return await checkJobFiledExist({ branchId, lob, jobFields, jobUuid }).then(res => res.data)
  }
  // 加载Job的关联实体信息
  async loadJobRelated(params) {
    params.jobUuid = params.jobUuid || this._data.uuid
    if (!params.jobUuid) {
      return
    }
    // 是否需要载入
    let needLoad = false
    // 将已经加载过的属性的标识置为false
    for (const key in params) {
      if (key === 'jobUuid') {
        continue
      }
      if (key !== 'job' && params[key] && typeof this._data[key] === 'object') {
        params[key] = false
      }
      if (params[key]) {
        needLoad = true
      }
    }
    if (!needLoad) {
      return
    }
    await loadIntegratedJobRelatedFunc(params).then(res => {
      const items = res.data
      if (items.job) {
        for (const key in items.job) {
          if (typeof this._data[key] === 'object') {
            continue
          }
          this._data[key] = items.job[key]
        }
      }
      for (const key in items) {
        if (key === 'job') {
          continue
        }
        this._data[key] = items[key] || null
      }
    })
  }
}
